import React, { FC, MutableRefObject, useCallback, useMemo } from "react";
import { observer } from "mobx-react-lite";
import styles from "./index.module.scss";
import { OrderItemType } from "@/pages/Order";
import config from "@/config";
import { orderLangRecords } from "@/pages/Order/lang";
import { langStore } from "@noli/business";

interface OrderItemProps {
  refs: any;
  total: number;
  data: OrderItemType[];
}
const OrderItem: FC<OrderItemProps> = (props) => {
  const lang = langStore.tgt;
  const { data, refs, total } = props;
  // 日期格式化
  const formatData = useMemo(() => {
    return (value: number) => {
      const date = new Date(value * 1000);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return `${year}${lang === "zh" ? "年" : "-"}${month < 10 ? "0" + month : month}${
        lang === "zh" ? "月" : "-"
      }${day < 10 ? "0" + day : day}${lang === "zh" ? "日" : "-"} ${
        hour < 10 ? "0" + hour : hour
      }:${minute < 10 ? "0" + minute : minute}:${second < 10 ? "0" + second : second}`;
    };
  }, []);
  const orderStateNode = useMemo(() => {
    return (value: number) => {
      switch (value) {
        case 3:
          return <span className={styles.completed}>{orderLangRecords[lang]["Completed"]}</span>;
        default:
          break;
      }
    };
  }, []);
  const orderStatusText = useMemo(() => {
    return (value: number) => {
      switch (value) {
        case 3:
          return orderLangRecords[lang]["OrderPaid"];
        default:
          break;
      }
    };
  }, []);
  const OrderItemNode = useMemo(() => {
    return data.map((item: OrderItemType) => {
      return (
        <li key={item.order_id}>
          <div className={styles.topStatusWrapper}>
            <div className={styles.leftWrapper}>
              <span className={styles.time}>{formatData(item.pay_time)}</span>
              <span className={styles.orderId}>订单号: {item.order_id}</span>
            </div>
            {orderStateNode(item.order_state_id)}
          </div>
          <div className={styles.orderContent}>
            <div className={styles.leftWrapper}>
              <img
                src={
                  item.product_type === "wenxin"
                    ? `${config.buildCdnBaseUrl}assets/creator/wenxin.png`
                    : `${config.buildCdnBaseUrl}assets/creator/accelerate.png`
                }
                className={styles.logo}
                alt=""
              />
              <div className={styles.orderInformation}>
                <p className={styles.name}>{item.name}</p>
                <p className={styles.price}>
                  {orderLangRecords[lang]["OriginalPrice"]} ¥ {item.price}
                </p>
                <p className={styles.activePrice}>¥{item.active_price}</p>
              </div>
            </div>
            <div className={styles.orderStatusText}>{orderStatusText(item.order_state_id)}</div>
          </div>
        </li>
      );
    });
  }, [data]);
  return (
    <div ref={refs} className={styles.orderListWrapper}>
      <ul className={styles.orderItemWrapper}>{OrderItemNode}</ul>
      {data.length === total && total && (
        <p className={styles.end}>{orderLangRecords[lang]["End-of-the-Page"]}</p>
      )}
    </div>
  );
};
export default observer(OrderItem);
